import { Container, Paper, SxProps, Theme } from '@mui/material';
import { PropsWithChildren } from 'react';
import { HeaderPublic } from 'shared/header';

const containerStyles: SxProps<Theme> = {
  marginTop: '30px',
};

export function PublicLayout({ children }: PropsWithChildren<{}>) {
  return (
    <div>
      <HeaderPublic />
      <Container sx={containerStyles} maxWidth={false}>
        <Paper>{children}</Paper>
      </Container>
    </div>
  );
}
